import React, {Component} from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import ApiActions from 'go/actions/api';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import _ from 'lodash';
import {Card, Grid, Input} from 'semantic-ui-react';
import {API_ORG_GET_BY_ID_SUCCESS} from 'common/types';

export class ApplicationHeader extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      showDetails: true,
      toggleMessage: 'Hide details',
      orgName: '',
      value: '',
    };
  }

  showHideDetails = () => {
    if (this.state.showDetails) {
      this.setState({
        showDetails: false,
        toggleMessage: 'Show details',
      });
    } else {
      this.setState({
        showDetails: true,
        toggleMessage: 'Hide details',
      });
    }
  };

  getOrg = () => {
    if (this.state.orgName === '') {
      const organizationId = _.get(
        this.props.dynamicComponent,
        this.props.organizationPath
      );
      this.props.getOrganizationInfo(this.props.token, organizationId).then((res) => {
        if (res.type === API_ORG_GET_BY_ID_SUCCESS) {
          this.setState({orgName: res.payload.displayName});
        }
      });
    }
  };

  handleMonthsChange = (e, valuePath) => {
    const targetValNumber = _.toNumber(e.target.value);
    if (_.isNaN(targetValNumber) === false) {
      if (targetValNumber > 0) {
        this.props.saveEntityData(valuePath, 'data', targetValNumber);
        this.setState({value: targetValNumber});
      } else {
        this.props.saveEntityData(valuePath, 'data', '0');
        this.setState({value: targetValNumber});
      }
    }
  };

  render() {
    const {title, grantId, amount, valuePath} = this.props;
    this.getOrg();
    const title_val = _.get(this.props.dynamicComponent, title);
    const grantId_val = _.get(this.props.dynamicComponent, grantId);
    const amount_val = _.get(this.props.dynamicComponent, amount);
    const amountString = !!amount_val
      ? amount_val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : 0;

    return (
      <Card fluid id="subAppHeader">
        <Card.Content>
          {this.state.showDetails ? (
            <Grid>
              <Grid.Row style={{paddingBottom: '0'}}>
                <Grid.Column width={4}>
                  <h5>Application title</h5>
                </Grid.Column>
                <Grid.Column width={3}>
                  <h5>Grant ID</h5>
                </Grid.Column>
                <Grid.Column width={3}>
                  <h5>Applicant name</h5>
                </Grid.Column>
                <Grid.Column width={3}>
                  <h5>Overall duration of the grant</h5>
                </Grid.Column>
                <Grid.Column width={3}>
                  <h5>Estimated federal share application amount</h5>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={4}>
                  <p id="app-header-title" className="textLarge">
                    <strong>{title_val}</strong>
                  </p>
                  <a
                    id="app-header-toggle"
                    className="link label"
                    color="blue"
                    onClick={this.showHideDetails}
                  >
                    {this.state.toggleMessage}
                  </a>
                </Grid.Column>
                <Grid.Column width={3}>
                  <p id="app-header-grant-id">{grantId_val}</p>
                </Grid.Column>
                <Grid.Column width={3}>
                  <p id="app-header-name">{this.state.orgName}</p>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Input
                    id="app-header-months"
                    style={{
                      height: '1.5em',
                      width: '4em',
                      marginRight: '.8em',
                    }}
                    value={this.state.value}
                    onChange={(e) => this.handleMonthsChange(e, valuePath)}
                  />
                  <span>month(s)</span>
                </Grid.Column>
                <Grid.Column width={3}>
                  <p id="app-header-amount" className="textLarge">
                    <strong>${amountString}</strong>
                  </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          ) : (
            <Grid>
              <Grid.Column width={8}>
                <p
                  id="app-header-title-compressed"
                  className="textLarge"
                  style={{float: 'left', marginBottom: 0}}
                >
                  <strong>{title}</strong>
                </p>
                <a
                  id="app-header-toggle-compressed"
                  className="link label padding-left"
                  color="blue"
                  onClick={this.showHideDetails}
                >
                  {this.state.toggleMessage}
                </a>
              </Grid.Column>
              <Grid.Column width={8}>
                <p style={{float: 'left', marginBottom: 0}}>
                  <strong>Estimated federal share application amount </strong>
                  <span id="app-header-amount-compressed" className="textLarge">
                    <strong>{`  $${amountString}`}</strong>
                  </span>
                </p>
              </Grid.Column>
            </Grid>
          )}
        </Card.Content>
      </Card>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    dynamicComponent: state.dynamicComponent,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  saveEntityData: (dataPath, entityType, data, fieldName) =>
    dispatch(
      DynamicComponentActions.saveEntityData(dataPath, entityType, data, fieldName, false)
    ),
  getOrganizationInfo: (token, orgId) => {
    const action = ApiActions.organization.getOrganizationById(token, orgId);
    const response = dispatch(action);
    return response;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationHeader);
